import { render, staticRenderFns } from "./Seo.vue?vue&type=template&id=5c2ce230"
import script from "./Seo.vue?vue&type=script&lang=js"
export * from "./Seo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports